import styled, { keyframes, css } from 'styled-components';
import React, { useState, useEffect } from 'react';

import Introduction from './screen/Introduction';
import Project from './screen/projectSet/Project';
import Introduce from './screen/Introduce';
import NullPage from './screen/NullPage';

import MobileIntroduction from './screen/mobile/MobileIntroduction';
import MobileIntroduce from './screen/mobile/mobilepjt/MobileIntroduce';
import { PC, Mobile } from './screen/ Responsive';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const fadeInRightToLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(100%);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

const FirstContainer = styled.div`
    align-items: center;
    animation: ${fadeInRightToLeft} 1s ease-in-out; /* 오른쪽에서 왼쪽으로 페이드인 애니메이션 */
`;

const Container = styled.div`
    align-items: center;
    animation: ${({ shouldFadeIn }) =>
        shouldFadeIn
            ? css`
                  ${fadeIn} 1s ease-in-out
              `
            : 'none'};
`;

if (process.env.NODE_ENV === 'production') {
    // production에서만 사용할 수 없도록
    console = window.console || {};
    console.log = function no_console() {}; // console log 막기
    console.warn = function no_console() {}; // console warning 막기
    console.error = function () {}; // console error 막기
}

function App() {
    const [scrollPosition, setScrollPosition] = useState(0);
    const [shouldFadeIn, setShouldFadeIn] = useState(false);
    const [threeFadeIn, setThreeFadeIn] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const currentPosition = window.scrollY;
            setScrollPosition(currentPosition);
            if (currentPosition >= 200) {
                setShouldFadeIn(true);
            }

            if (currentPosition > window.innerHeight * 1.2) {
                setThreeFadeIn(true);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <>
            <Mobile>
                <FirstContainer>
                    <MobileIntroduction />
                </FirstContainer>
                {!shouldFadeIn ? (
                    <NullPage />
                ) : (
                    <Container shouldFadeIn={shouldFadeIn}>
                        <MobileIntroduce />
                    </Container>
                )}
                {!threeFadeIn ? (
                    <NullPage />
                ) : (
                    <Container shouldFadeIn={threeFadeIn}>
                        <Project />
                    </Container>
                )}
            </Mobile>
            <PC>
                <FirstContainer>
                    <Introduction />
                </FirstContainer>
                {!shouldFadeIn ? (
                    <NullPage />
                ) : (
                    <Container shouldFadeIn={shouldFadeIn}>
                        <Introduce />
                    </Container>
                )}
                {!threeFadeIn ? (
                    <NullPage />
                ) : (
                    <Container shouldFadeIn={threeFadeIn}>
                        <Project />
                    </Container>
                )}
            </PC>
        </>
    );
}

export default App;
